// format the name, value and order of element properties represented in the nodes array
export function normalize (nodes) {
  let normalizedNodes = [];
  nodes.forEach((node, idx) => {
    normalizedNodes.push(normalizeNode(node));
  });
  return normalizedNodes;
}

let htmlEscape = {
  '&': '&amp;',
  '=': '&#61;',
  '\'': '&#39;',
  '\0': '&#00;',
  '\v': '&#11;',
  '\n': '&#12;',
  '\\[': '&#91;',
  '\\]': '&#93;'
};
function normalizeAttribute (attr) {
  if (attr.value) {
    attr.value = replaceAll(attr.value.trim(), htmlEscape);
  }
  return attr;
}

function normalizeClassName (attr) {
  // repalce 2 or more white space chars with a single space
  let value = attr.value.replace(/\s\s+/g, ' ');
  let className = value.split(' ').sort();
  if (attr.operator === '*=') {
    attr.value = value;
  } else {
    attr.value = '.' + className.join('.');
  }
  return attr;
}

function normalizeNode (node) {
  let mainAttrMap = {}; // tag, id and class
  let nodeAttrMap = {}; // src, href, data-xxx etc
  let pseudoAttrMap = {}; // pseudo attributes such as :nth-of-type
  node.forEach((attr) => {
    let name = attr.name.toLowerCase();
    if (['tag', 'id', 'class'].indexOf(name) >= 0) {
      if (name === 'tag') {
        attr.value = attr.value.toLowerCase();
      } else if (name === 'class') {
        attr = normalizeClassName(attr);
      }
      mainAttrMap[name] = attr;
    } else if (name.indexOf(':') === 0) {
      pseudoAttrMap[name] = attr;
    } else {
      attr = normalizeAttribute(attr);
      nodeAttrMap[name] = attr;
    }
  });
  let propList = [];
  if (mainAttrMap.tag) {
    propList.push(mainAttrMap.tag);
  }
  if (mainAttrMap.id) {
    propList.push(mainAttrMap.id);
  }
  if (mainAttrMap['class']) {
    propList.push(mainAttrMap['class']);
  }
  propList = propList.concat(mapToArrayByKey(nodeAttrMap));
  propList = propList.concat(mapToArrayByKey(pseudoAttrMap));
  return propList;
}

// convert map of name value pairs to array ordered by name
function mapToArrayByKey (map) {
  let list = [];
  let keys = Object.keys(map).sort();
  keys.forEach((key) => {
    list.push(map[key]);
  });
  return list;
}

// give a set of chars (defined in mapObj), replace them with another set of chars
function replaceAll (str, mapObj) {
  let regex = new RegExp(Object.keys(mapObj).join('|'), 'gi');
  return str.replace(regex, (matched) => {
    return mapObj[matched.toLowerCase()] || mapObj['\\' + matched.toLowerCase()];
  });
}



/** WEBPACK FOOTER **
 ** ./src/utils/normalize.js
 **/